import styles from './profile-settings.module.scss'
import { RightArrowSvgIcon } from '../../util/images'
import { Link } from 'react-router-dom'
import { DropdownMenuItem } from 'src/component/ui/dropdown-menu'

interface ProfileSettingsDropdownMenuItemProps {
  to: string
  children: React.ReactNode
  isActive?: boolean
  className?: string
}

export const ProfileSettingsDropdownMenuItem = ({
  to,
  children,
  isActive = false,
  className = '',
}: ProfileSettingsDropdownMenuItemProps): React.ReactElement => {
  return (
    <DropdownMenuItem asChild className={`mb-3 ${className}`}>
      <Link
        to={to}
        className={`d-flex justify-between align-center font-evogria text-small uppercase hover:text-primary hover:no-underline ${
          styles.link
        } ${isActive ? styles.active : ''}`}
      >
        {children}
        <RightArrowSvgIcon data-testid="right-arrow-icon" />
      </Link>
    </DropdownMenuItem>
  )
}
